import { FC } from 'react';
import styles from './Card.module.scss';

export const Card: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <div className={styles.card}>{children}</div>
);
